import React, { useState, useEffect, useRef, createRef } from "react";
import { observer } from "mobx-react";
import { ImageMap } from "@qiuz/react-image-map";
import { useRouterStore, useAuthStore } from "../../stores";
import { Modal, Input, Form } from "antd";
import Text from "antd/lib/typography/Text";
import { getLocalStorage } from "../../utils";

import pageImg from "./lonelypop_game-05-min.png";

const WelcomePage = () => {
  const { history } = useRouterStore();
  const [score, setScore] = useState<any>("Loading");
  const mapArea = [
    {
      left: "15%",
      top: "63%",
      height: "8%",
      width: "65%",
    },
  ];

  const onMapClick = async (area: any, index: any) => {
    switch (index) {
      // login
      case 0:
        history.push("/");

        break;
    }
  };

  const ImageMapComponent = React.useMemo(
    () => (
      <ImageMap
        className="usage-map"
        src={pageImg}
        map={mapArea}
        onMapClick={onMapClick}
      />
    ),
    [mapArea, pageImg]
  );

  useEffect(() => {
    setTimeout(async () => {
      const score: any = localStorage.getItem("score");
      setScore(parseInt(score));
    }, 1000);
  }, []);

  return (
    <div className="main_wrapper">
      <div className="landing">
        <div
          className="step step_0"
          style={{
            background: `url(${pageImg}) left top no-repeat`,
          }}
        >
          <div className="content">
            {ImageMapComponent}

            {typeof score === "string" ? (
              <div
                style={{
                  position: "absolute",
                  top: "45%",
                  width: "100%",
                  height: "10%",
                  fontSize: "8em",
                  left: "40%",
                  fontWeight: 1000,
                  color: "#ffdb0d",
                }}
              >
                <p
                  style={{
                    WebkitTextStrokeWidth: 10,
                    WebkitTextStrokeColor: "black",
                  }}
                >
                  {score}
                </p>
              </div>
            ) : (
              <div
                style={{
                  position: "absolute",
                  top: "40%",
                  width: "100%",
                  height: "10%",
                  fontSize: "17em",
                  left: "40%",
                  fontWeight: 1000,
                  color: "#ffdb0d",
                }}
              >
                <p
                  style={{
                    WebkitTextStrokeWidth: 14,
                    WebkitTextStrokeColor: "black",
                  }}
                >
                  {score}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default observer(WelcomePage);
